import React, { useEffect, useState } from "react";
import * as yup from "yup";
import Grid from "@material-ui/core/Grid";
import { toast } from "react-toastify";
import { Principal } from "@dfinity/agent";
import { H2 } from "@origyn-sa/common-ui/src/components/atoms/H/H.styled";
import { ReactComponent as AddIcon } from "@origyn-sa/common-ui/src/assets/icons/add.svg";
import InputField from "@origyn-sa/common-ui/src/components/molecules/InputField";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import PaymentMethodCard from "@origyn-sa/common-ui/src/components/molecules/PaymentMethodCard";
import { fetchPaymentMethods } from "../../utils";
import Form from "@origyn-sa/common-ui/src/components/templates/Form";
import HR from "@origyn-sa/common-ui/src/components/atoms/HR/HR.styled";
import PaymentMethodModal from "./PaymentMethodModal";
import { client, ICPClient } from "../../agent";
import { PaymentMethodType } from "@origyn-sa/common-ui/src/api/types";
import { LinearProgress } from "@material-ui/core";

const schema = yup.object().shape({
  administrator: yup.string().required(),
});

const MarketplaceSettings = () => {
  const [loader, setLoader] = useState<boolean>(true);
  const [isAddOpened, setIsAddOpened] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethodType[]>([]);
  const [errors, setErrors]: [{ [key: string]: string }, any] = useState({});

  const handleValidation = (data: any) => {
    setErrors(data);
  };

  const refreshPaymentMethods = () => {
    setLoader(true);
    fetchPaymentMethods()
      .then((data: PaymentMethodType[]) => {
        setPaymentMethods(data);
      })
      .finally(() => setLoader(false));
  };

  useEffect(() => {
    const interval = setInterval(() => refreshPaymentMethods(), 10000);
    return () => clearInterval(interval);
  }, []);

  const togglePaymentMethod = async (paymentMethod: any) => {
    try {
      await client.actor.updatePaymentMethod({
        kind: {
          origynFTv1StandardKind: null,
        },
        _principal: Principal.fromText(paymentMethod._principal),
        enabled: !paymentMethod.enabled,
      });
      refreshPaymentMethods();
      toast.success(`Payment method updated`);
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <>
      {loader && (
        <LinearProgress
          style={{ position: "fixed", top: 0, left: 0, width: "100%" }}
        />
      )}
      <H2 spacing={3.75}>Settings</H2>
      <Form
        action='transfer'
        schema={schema}
        onValidation={handleValidation}
        style={{ maxWidth: 704 }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <InputField
              error={errors.canisterID}
              disabled
              label='Canister ID'
              name='canisterID'
              placeholder='Canister ID'
              defaultValue={ICPClient.getCanisterId()}
            />
          </Grid>
        </Grid>
        <Grid>
          <Button type='submit' disabled spacing={2}>
            save changes
          </Button>
        </Grid>
        <HR />
        <H2 spacing={3.75}>Payment Methods</H2>

        <Grid container spacing={3}>
          {paymentMethods.length ? (
            paymentMethods.map((item: PaymentMethodType) => (
              <PaymentMethodCard
                key={item.id}
                onStatusChange={() => togglePaymentMethod(item)}
                paymentMethod={item}
              />
            ))
          ) : (
            <></>
          )}
        </Grid>
        <Grid>
          <Grid>
            <Button
              small
              outlined
              fullWidth
              spacing={2}
              onClick={() => setIsAddOpened(true)}
            >
              <AddIcon />
              Add payment method
            </Button>
          </Grid>
        </Grid>
      </Form>
      <PaymentMethodModal
        open={isAddOpened}
        onClose={() => setIsAddOpened(false)}
      />
    </>
  );
};

export default MarketplaceSettings;
